import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  datasetYX,
  xLinear,
  yBand,
  initBarParallel,
  barAnimation,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  initPivot,
  datasetPivot,
  pivotDiscreteLegend,
  pivotIndicators,
  pivotAdapter,
  pivotIndicatorsAsCol,
  pivotGridStyle,
  pivotRowDimensions,
  pivotColumnDimensions,
  barStyle,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationDifferenceLine,
  annotationAreaBand,
  horizontalCrosshairRect,
  barCornerRadius,
  progressive,
  linearColor,
  colorAdapter,
  colorLegend,
  colorBarStyleFill,
  pivotColorLegend,
  barMaxWidth,
  barGapInGroup,
  pivotAxisStyle,
  pivotTitle,
  dimensionLinkage,
  brush,
  fontFamilyTheme,
  regionPadding,
} from '../pipes'

const barParallel: VChartSpecPipeline = [
  fontFamilyTheme,
  initBarParallel,
  barAnimation,
  regionPadding,
  barCornerRadius,
  barMaxWidth,
  barGapInGroup,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetYX,
  animationMorph,
  progressive,
  xLinear,
  yBand,
  label,
  brush,
  tooltip({ titleEncoding: 'y' }),
  colorAdapter(discreteLegend, colorLegend),
  horizontalCrosshairRect,
  colorBarStyleFill(barStyle),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationDifferenceLine,
  annotationAreaBand,
]

const pivotBarParallel: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsCol,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initBarParallel,
    barAnimation,
    regionPadding,
    barCornerRadius,
    barMaxWidth,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetYX,
    animationMorph,
    xLinear,
    pivotAxisStyle(yBand),
    brush,
    label,
    tooltip({ titleEncoding: 'y' }),
    colorBarStyleFill(barStyle),
    horizontalCrosshairRect,
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationDifferenceLine,
    annotationAreaBand,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const barParallelSpecPipeline = [pivotAdapter(barParallel, pivotBarParallel)]
